import React, { FC } from 'react'
import { Box } from '@mui/material'
import clsx from 'clsx'
import dayjs from 'dayjs'
import { AppointmentCard } from './AppointmentCard'
import { BetmenListItemCard } from '../../../../../common/components'
import { useExtraBetmenListItemCardStyle } from '../../../../../utils'
import { useTreatmentPanelData } from '../TreatmentPanel/TreatmentPanelProvider'
import { TreatmentAppointmentItemComponentViewModel } from '../../types/treatmentItem.types'

interface Props {
  vm: TreatmentAppointmentItemComponentViewModel
}

const TreatmentAppointmentItemComponent: FC<React.PropsWithChildren<Props>> = ({
  vm: {
    appointment,
    linking,
    disableLinking,
    canLinkTo,
    onClick,
    editAppointment,
    cloneAppointment,
    onLink,
  },
}) => {
  const { showPastTreatmentItems, setHoveredTreatmentItem } =
    useTreatmentPanelData()
  const classes = useExtraBetmenListItemCardStyle()

  const isPast = dayjs().startOf('day') > dayjs(appointment.proposedDate)

  const handleLink = () => {
    onLink(appointment)
  }

  return !showPastTreatmentItems && isPast ? null : (
    <Box>
      <BetmenListItemCard
        className={clsx(classes.container, {
          [classes.past]: isPast,
        })}
        mb={1}
        id={`arrow-row-${appointment.id}`}
        onMouseEnter={() => {
          setHoveredTreatmentItem({
            id: appointment.id,
            date: dayjs(appointment.proposedDate),
          })
        }}
        onMouseLeave={() => {
          setHoveredTreatmentItem(null)
        }}
        onClick={() => onClick(appointment.id)}
        minHeight={40}
        data-id={appointment?.id}
        data-cy={`AppointmentHeader-Box-${appointment?.id}`}
      >
        <AppointmentCard
          appointment={appointment}
          isPast={isPast}
          editAppointment={editAppointment}
          cloneAppointment={cloneAppointment}
          linking={linking}
          disableLinking={disableLinking}
          canLinkTo={canLinkTo}
          onLink={handleLink}
        />
      </BetmenListItemCard>
    </Box>
  )
}

const TreatmentAppointmentItem = React.memo(TreatmentAppointmentItemComponent)

export { TreatmentAppointmentItem }
